/**
 * 儀表板數字卡（P1-12；`ui-spec` §2 頁 2）
 *
 * 用途：一格顯示「一個數」＋ 一行提示（例「待收貨 3 批」）。
 * ⚠️ 有 `to` 就係一條連結（用 `Link`，SPA 換頁唔會重新載入）；
 *    冇 `to` 就淨係顯示（例：本週 cbm 係唯讀資訊）。
 * ⚠️ 顏色一律用 `@coeldery/ui-kit` tokens（唔准 hex）；警示用 `tone="warn"`。
 */
import { Link } from 'react-router-dom';
import { badge, card, hint as hintStyle } from '@coeldery/ui-kit';

export interface StatCardProps {
  label: string;
  /** 已經砌好嘅顯示值（例 `'3'`／`'12.345600 cbm'`）—— 呢個元件唔負責格式 */
  value: string;
  hint?: string;
  tone?: 'normal' | 'warn';
  to?: string;
}

export default function StatCard({ label, value, hint, tone = 'normal', to }: StatCardProps) {
  const body = (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={hintStyle}>{label}</span>
        {tone === 'warn' && <span style={badge('warn')}>⚠️</span>}
      </div>
      <div
        style={{
          marginTop: '6px',
          fontSize: '24px',
          fontWeight: 800,
          fontVariantNumeric: 'tabular-nums',
          color: tone === 'warn' ? 'var(--color-accent)' : 'var(--color-text)',
        }}
      >
        {value}
      </div>
      {hint && <p style={{ ...hintStyle, margin: '6px 0 0' }}>{hint}</p>}
    </>
  );

  const style = { ...card, padding: '14px 16px', display: 'block', textDecoration: 'none' };
  return to ? (
    <Link to={to} style={style}>
      {body}
    </Link>
  ) : (
    <section style={style}>{body}</section>
  );
}
